<template>
  <div class="pricing container-fluid" id="pricing">
    <div class="row">
      <div class="line-1 col-md-6 p-5 bg-white text-center d-flex flex-column justify-content-center align-items-center">
        <h1 class="title">Kosten</h1>
        <div class="sub-title w-75">
          Het beheren van contacten en het versturen van facturen is gratis, en dat zal ook zo blijven.
          We hopen op termijn de app aan te vullen met geavanceerde functies waar ondernemers een vergoeding voor
          over hebben. Geen zorgen, de functies die je nu kan gebruiken blijven gratis. SimpleFinance moet altijd een
          uitkomst blijven voor de kleine ondernemer.
        </div>
      </div>
      <div class="line-1 col-md-6 bg-green d-flex flex-column justify-content-center align-items-center">
        <img
            src="../../assets/img/ipad.png"
            class="img-fluid p-5"
            data-aos="fade"
            data-aos-duration="1000"
            data-aos-once="false"
        />
      </div>
    </div>
    <div class="row flex-column-reverse flex-md-row">
      <div class="col-md-6 bg-green d-flex flex-column justify-content-center align-items-center">
        <img
            class="cis-logo m-5"
            src="../../assets/img/logo-cis-solo.svg"
            alt="CISolutions logo"
            data-aos="fade"
            data-aos-duration="1000"
            data-aos-once="false"
        />
      </div>
      <div class="col-md-6 p-5 bg-white text-center d-flex flex-column justify-content-center align-items-center">
        <h1 class="title">De kleine letters</h1>
        <div class="sub-title">
          SimpleFinance wordt gemaakt door CISolutions. Als ondernemers begrijpen we hoe belangrijk de gegevens zijn
          die aan ons worden toevertrouwd. Wil je stoppen met , of heb je jouw gegevens nodig voor een ander programma?
          Dan helpen we je daarbij. Download je gegevens in een bestandsformaat dat je nodig hebt, of verwijder alles
          van onze servers wanneer je dat wil.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pricing'
};
</script>

<style scoped>
.pricing .row {
  min-height: 700px;
}

.bg-green {
  background-color: #74E5CE;
}

.cis-logo {
  width: 50%;
}
</style>
